import { render, staticRenderFns } from "./resolutionTimeCrit.vue?vue&type=template&id=206ce6ae"
import script from "./resolutionTimeCrit.vue?vue&type=script&lang=js"
export * from "./resolutionTimeCrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports